import type { SmRole } from "@/domain/sm-models";
import { useCallback, useEffect, useState } from "react";
import { APP_REFRESH_EVENT } from "@/lib/sm-app-events";
import { authService } from "@/lib/services";

export interface SessionUser {
  id: string;
  email: string;
  name: string;
  role: SmRole;
  tenantId: string | null;
  staffPermissions?: Record<string, boolean> | null;
  operationalRoleId?: string | null;
  locationIds?: string[];
  locationRoles?: Record<string, string>;
  avatarUrl?: string | null;
  themeMode?: "dark" | "light" | "system" | null;
}

export function useSession() {
  const [user, setUser] = useState<SessionUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(async () => {
    setIsLoading(true);
    const u = await authService.getCurrentUser();
    setUser(u as SessionUser | null);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    void load();
    const fn = () => void load();
    window.addEventListener(APP_REFRESH_EVENT, fn);
    return () => window.removeEventListener(APP_REFRESH_EVENT, fn);
  }, [load]);

  const logout = useCallback(async () => {
    await authService.logout();
    setUser(null);
    // Redirect duro a /acceso/comercio: recarga la app sin cookie de sesión, evitando que
    // queden fetches autenticados en vuelo (admin/owner) que disparen toasts de
    // "No autorizado" al cerrar sesión.
    if (typeof window !== "undefined") window.location.assign("/acceso/comercio");
  }, []);

  return { user, isLoading, logout, refresh: load };
}
